import { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/system'
import Radio from '@mui/material/Radio'
import { ColDef, Column, GridApi, RowNode } from 'ag-grid-community'
import { addEventListenerForLastRow } from '../../../../index'
import { moveFocusByArrowKey } from '../../../../lib/navigator'

// Styles
const RootDiv = styled('div')({
  width: '100%',
  height: '100%',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
})

interface Props {
  value: string
  node: RowNode
  colDef: ColDef
  api: GridApi
  column: Column
  gridApi: GridApi
  rowIndex: number

  field: string
  radioValue: string
  onValueChange: (value: any) => void
}

const RadioGroupCellEditor = (props: Props) => {
  const [value, setValue] = useState(props.value)
  const inputRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
      addEventListenerForLastRow(inputRef.current, props)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- マウント時のみ実行。セルエディタの初期化処理
  }, [])

  const handleSetValue = () => {
    props.onValueChange(props.radioValue)
    setValue(props.radioValue)
    props.node.setDataValue(props.field, props.radioValue)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event && event.keyCode === 32) {
      // space
      handleSetValue()
    }
    moveFocusByArrowKey(event, props.node, props.column, props.api, props.api)
  }

  const handleBlur = () => {
    props.api.stopEditing()
  }

  return (
    <RootDiv>
      <Radio
        name={props.field}
        value={props.radioValue}
        checked={value === props.radioValue}
        onChange={() => handleSetValue()}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        inputRef={inputRef}
        tabIndex={1}
      />
    </RootDiv>
  )
}

export default RadioGroupCellEditor
